import { Auth } from "aws-amplify"

export const order = {
  namespaced: true,
  state: {
    order: null,
    orders: null,
  },
  mutations: {
    setOrder(state, payload) {
      state.order = payload
      console.log('order set to:', state.order)
    },
    setOrders(state, payload) {
      state.orders = payload
      console.log('order history set to:', state.orders)
    }
  },
  actions: {
    async getOrders(context) {
      // context.commit('utils/setIsLoadingOverlay', true, { root: true }) 
      try {
        const currentSession = await Auth.currentSession()
        const accessToken = await currentSession.getAccessToken()
        const jwt = await accessToken.getJwtToken()

        const response = await fetch(`${process.env.VUE_APP_API_URL}/orders-history/`, {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${jwt}`,
          },
        })
        const data = await response.json()
        context.commit('setOrders', data)
        // context.commit('utils/setIsLoadingOverlay', false, { root: true }) 
      } catch (error) {
        console.log(error)
      }
    }
  }
}



